import { ROOT } from "@/services/resource-service/entity/Enums";

export interface ITreeInfo {
  guid: string;
  name: string | any;
  iconKey?: string;
  iconColor?: string;
  isDefault?: boolean;
  isFavorite?: boolean;
  parentId?: string;
  children?: ITreeInfo[];
  isCollapsed?: boolean;
  iconClosed: JSX.Element | null;
  isDisabled: boolean;
  isUsedFloorPlan?: boolean;
  defaultParent?: string;
}

export interface ICategorizationInfo {
  guid: string;
  name: string | any;
  iconKey?: string;
  iconColor?: string;
  isDefault?: boolean;
  isFavorite?: boolean;
  parentId?: string;
  iconClosed: JSX.Element | null;
  isDisabled: boolean;
  isUsedFloorPlan?: boolean;
  defaultParent?: string;
}

export class TreeInfo {
  guid: string;
  name: string | any;
  iconKey: string;
  iconColor: string;
  isDefault?: boolean;
  isFavorite?: boolean;
  parentId: string;
  parentIds: string[] = [];
  children: TreeInfo[];
  isCollapsed?: boolean;
  childDeep: string[] = [];
  iconClosed: JSX.Element | null;
  isDisabled: boolean;
  isUsedFloorPlan: boolean;
  defaultParent: string;

  constructor(data?: ITreeInfo, parentIds?: string[]) {
    this.guid = String(data?.guid) || "";
    this.name = data?.name || "";
    this.iconKey = data?.iconKey || "";
    this.iconColor = data?.iconColor || "";
    this.isDefault = !!data?.isDefault;
    this.isDefault = !!data?.isDefault;
    this.isFavorite = !!data?.isFavorite;
    this.parentId = data?.parentId ? String(data?.parentId) : "";
    this.iconClosed = data?.iconClosed || null;
    if (parentIds?.length) {
      parentIds.push(this.parentId);
      this.parentIds = [...new Set(parentIds)];
    } else {
      this.parentIds.push(this.parentId);
      this.parentIds = [...new Set(this.parentIds)];
    }
    this.children = data?.children?.length
      ? data.children.map(
          (item: any) => new TreeInfo(item, [...new Set(this.parentIds)])
        )
      : [];
    this.isCollapsed = !data?.isCollapsed;
    this.isDisabled = !!data?.isDisabled;
    this.isUsedFloorPlan = !!data?.isUsedFloorPlan;
    this.defaultParent = data?.defaultParent || ROOT
  }

  setParentIds(parentIds?: string[], isCollapsed?: boolean) {
    if (isCollapsed) {
      this.isCollapsed = !isCollapsed;
    }
    if (parentIds?.length && this.parentId) {
      parentIds.push(String(this.parentId));
      this.parentIds = [...new Set(parentIds)];
    } else if (this.parentId) {
      this.parentIds.push(String(this.parentId));
      this.parentIds = [...new Set(this.parentIds)];
    }
    if (!this.parentIds[0]) {
      this.parentIds[0] = this.defaultParent;
    }
    if (this.children.length) {
      this.children.map((item: TreeInfo) => {
        item.setParentIds([...new Set(this.parentIds)], isCollapsed);
        return item;
      });
    }
  }

  getChildIds(node: TreeInfo) {
    const childIds: string[] = [];
    if (node.children) {
      for (const childNode of node.children) {
        childIds.push(childNode.guid);
        childIds.push(...this.getChildIds(childNode));
      }
    }
    return childIds;
  }

  setChildDeep() {
    this.childDeep = this.getChildIds(this);
    if (this.children.length) {
      this.children.map((item: TreeInfo) => {
        item.setChildDeep();
        return item;
      });
    }
  }

  setExpand(listExpand: string[]) {
    if (listExpand.includes(this.guid)) {
      this.isCollapsed = false;
    }
    if (this.children.length) {
      this.children.map((item: TreeInfo) => {
        item.setExpand(listExpand);
        return item;
      });
    }
  }
}

export interface ITreeSelectProps {
  items: ITreeInfo[];
  loading?: boolean;
  rcName?: string;
  values?: string[];
  styles?: any;
  size?: string;
  lblSelect?: string;
  onChange?: (listValue: string[], onlyParentId?: string) => void;
  actionFavorites?: (node: any) => void;
  isSingle?: boolean;
  isDisplayOnlyTree?: boolean;
  style?: any;
  expanded?: string[];
  showRadio?: boolean;
  condition?: string;
  onCheckCondition?: (condition: string) => void;
  iconLeft?: JSX.Element;
  iconLeftActive?: JSX.Element;
  isNormalLogic?: boolean;
  isNotCheckbox?: boolean;
  showExpandAll?: boolean;
  displayLabelValue?: string;
  isOnlySelectOneValue?: boolean;
  onToggleShow?: (showContextualMenu?: boolean) => void;
  blockNodeRightClick?: number[];
  disabled?: boolean;
  onApply?: (arr?: string[]) => void;
  onClear?: (arr?: string[]) => void;
  align?: EAlignment;
  theme?: string;
  showIconClear?: boolean;
}

export interface ITreeCheckboxProps {
  node: TreeInfo;
  values: string[];
  onChange?: (items: string[], onlyParentId?: string) => void;
  rcName?: string;
  mappingValueToListChild?: Record<string, string[]>;
  actionFavorites?: (node: any) => void;
  isSingle?: boolean;
  expanded?: string[];
  isNormalLogic?: boolean;
  isNotCheckbox?: boolean;
  size?: string;
  isOnlySelectOneValue?: boolean;
  blockNodeRightClick?: number[];
  theme?: string;
}

export interface IRefComponentTypeTreeSelect {
  onChangeToggleContextMenu?: (isShow: boolean) => void
}

export enum EAlignment {
  TOP = "top",
  BOTTOM = "bottom",
  START = "start",
  END = "end",
  CENTER = "center",
}

export enum EPosition {
  ABOVE = "above",
  BELOW = "below",
  BEFORE = "before",
  AFTER = "after",
}

export const SMALL = "small";
